export type ActivityTag = 'scuba_diving';

export const ACTIVITY_TAG_OPTIONS: { value: ActivityTag; label: string }[] = [
  { value: 'scuba_diving', label: 'Scuba Diving' },
];

export function getActivityTagLabel(value: string): string {
  return ACTIVITY_TAG_OPTIONS.find((option) => option.value === value)?.label || value;
}
